module.exports = __webpack_public_path__ + "media/images/vip-badge-e6b20bf510a93b940e5ec11f1e4afa44.svg";